import React from 'react'

const HomePage = () => (
    <div>
        <h1>Welcome to SSA Box Manager v9000.1.2</h1>
    </div>
)

export default HomePage